import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { RfqService } from '@app/core/quotes';

@Component({
  selector: 'cnc-update-alternate-skus',
  templateUrl: './update-alternate-skus.component.html',
  styleUrls: ['./update-alternate-skus.component.scss'],
})
export class UpdateAlternateSkusComponent implements OnInit {
  formData :UntypedFormGroup;
  pageTitle :string = 'Update SKU Alternate SKUs';
  submitted :boolean = false;
  loading :boolean = false;

  @Input() rfq :any;
  alternateSKUs :any[] = [];
  alternate_sku :string = '';

  constructor(
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    private toastr :ToastrService,
    private rfqSvc :RfqService,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      transfer_type: [null, [Validators.required]],
      locations: [null, [Validators.required]],
      rfq: [null, [Validators.required]],
      previous_locations: this.fb.array([]),
    });
    this.getAlternateSKU({ id: this.rfq.id });
  }

  private getAlternateSKU(payload :any) :void {
    this.rfqSvc.getAlternateSKU(payload).subscribe((res) => {
      this.alternateSKUs = res;
    });
  }

  addSKU() {
    if (this.loading || this.alternate_sku.trim() == '') {
      return;
    }
    this.loading = true;
    const data = {
      rfq_id: this.rfq.id,
      sku: this.rfq.internal_sku,
      alternate_sku: this.alternate_sku,
    };
    this.rfqSvc.addAlternateSKU(this.rfq.id, data).subscribe(
      (resp) => {
        this.toastr.success('Added.');
        this.alternate_sku = '';
        this.loading = false;
        this.getAlternateSKU({ id: this.rfq.id });
      },
      (err) => {
        this.toastr.error('Error!', err.error.error);
        this.loading = false;
      },
    );
  }

  removeAlternateSku(idx) {
    this.rfqSvc
      .deleteAlternateSKU(this.rfq.id, this.alternateSKUs[idx].id)
      .subscribe((resp) => {
        this.toastr.success('Deleted.');
        this.getAlternateSKU({ id: this.rfq.id });
      });
  }
}
